import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DisableControlDirective } from './disableControl.directive';
import { InputCurrencyDirective } from "./inputCurrency.directive";

@NgModule({
  declarations: [DisableControlDirective,
    InputCurrencyDirective
  ],
  imports: [CommonModule],
  exports: [DisableControlDirective, InputCurrencyDirective],
})
export class DirectiveModule { }
